import React, { Fragment } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

function Input_MeasurementSetting(props) {
  return (
    <Fragment>
      <div className="form-control-customed single_input" style={props.style}>
        <div style={{ height: "23px" }}>
          <label for="testName">{props.label}</label>
        </div>
        <div style={{ clear: "both" }}></div>
        <div>
          {/* <input name="myInput" /> */}
          {/* UpdateMeasurementAttributePopup */}
          <div style={{ width: "25px", float: "left" }}>
            <input
              name="testName"
              className="single_input_text"
              id="testName"
              type="text"
              value=""
            />
          </div>
          <button
            onClick={() => {
              props.edit_measurementSettingsDetailsByGUID(
                props.guid,
                props.isExtendedNote
              );
            }}
            type="button"
            className="btn btn-light"
          >
            <i className="fa fa-edit"></i>
          </button>
          &nbsp;
          <button
            onClick={() => {
              props.delete_MeasurementSettingsDetailsByGUID(props.guid);
            }}
            type="button"
            className="btn btn-light"
          >
            <i className="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </Fragment>
  );
}

export default Input_MeasurementSetting;
